import moment from 'moment';
import { formatAmount } from '/src/lib/helpers';

const refactorDateData = (data) => {
    for (let i = 0; i < data.length; i++) {
        let k = 1;
        for (let j = 0; j < data.length; j++) {
            if (i != j) {
                if (data[j].date_display === data[i].date_display) {
                    data[j].date_display = `${data[j].date_display} (${k})`;
                    k++;
                }
            }
        }
    }
    return data;
}

export const getFundingChartsData = (fundingRounds, setState) => {
    let fundingRoundsData = fundingRounds, dataForChart = [], amountToDisplay = 0;

    // Hide the chart if there is no data or data was reset after auth token expired
    if (fundingRoundsData?.length === 0) {
        setState(prevState => ({ ...prevState, showFundingEvolutionChart: false }))
        return;
    }

    // Forma breakdowns data required for the chart from rounds
    fundingRoundsData.map((item) => {
        item.funding_breakdowns_data.map(breakdown => {
            dataForChart.push({
                date_raised: breakdown.date_raised,
                date_display: moment(breakdown.date_raised).format("MMM'YY"),
                amount_raised: breakdown.amount,
                funding_stage: item.funding_stage_data?.name,
                investment_vehicle: breakdown.investment_vehicle_data?.name,
                undisclosed_amount: Number(breakdown.undisclosed_amount) || 0
            });

            if (breakdown.amount > 0 || breakdown.undisclosed_amount > 0)
                amountToDisplay++;
        })
    });

    // Hide the chart if all funding rounds are undisclosed and there are no available undisclosed proxy
    if (amountToDisplay == 0) {
        setState(prevState => ({ ...prevState, showFundingEvolutionChart: false }))
        return;
    }

    // Sorting by date raised ascending
    dataForChart.sort((a, b) => new Date(a.date_raised) - new Date(b.date_raised));

    // Refactor date to add incase there are two breakdowns with exact same timestamp
    dataForChart = refactorDateData(dataForChart);

    let dataset = dataForChart.map((d, i) => ([d.date_display, d.amount_raised, d.undisclosed_amount, d.investment_vehicle]));
    let tooltip_data = dataForChart.map((d) => ([d.date_display, d.funding_stage, d.investment_vehicle, d.amount_raised ? formatAmount(d.amount_raised) : (d.undisclosed_amount ? `${formatAmount(d.undisclosed_amount)} (Estimated)` : 'Undisclosed')]));

    setState(prevState => ({
        ...prevState,
        fundingEvolutionChart: {
            ...prevState.fundingEvolutionChart,
            dataset: dataset,
            tooltip_data: tooltip_data
        },
        showFundingEvolutionChart: true,
    }));
}
